import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from 'src/app/_services/admin/users.service';
import { InventoryService } from 'src/app/_services/inventory.service';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { AuthenticationService } from 'src/app/auth/authentication.service';

@Component({
    selector: 'app-add-edit-user-bins',
    templateUrl: './add-edit-user-bins.component.html',
    styleUrls: ['./add-edit-user-bins.component.scss'],
    standalone: false
})
export class AddEditUserBinsComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  data: any;
  addLocationForm: UntypedFormGroup;
  submitTouched!: boolean;
  users: any[] = [];
  translate: any;
  mode!: string;

  constructor(
    public modalRef: BsModalRef,
    private inventoryService: InventoryService,
    private spinner: NgxSpinnerService,
    private userService: UsersService,
    private auth: AuthenticationService,
    private errorUtil: ErrorUtil,
    private languageTranslateService: LanguageTranslateService,
  ) {
    super();
    this.getLanguageData();
    this.addLocationForm = new UntypedFormGroup({
      'user': new UntypedFormControl(null, [Validators.required]),
      'displayName': new UntypedFormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.userService.getAllDownlineUsersForInventryLocationAndZone(this.auth.getUserId(), true).subscribe((res: any) => {
      this.users = _.filter(res, (o) => {
        return o.userType == null || o.userType.sysName != 'DRIVER';
      });
      this.users.forEach(element => {
        element.fullName = element.firstName + " " + element.lastName;
      });

      if (this.mode === 'edit' && this.data) {
        this.patchEditData();
      }
    });
  }

  private patchEditData() {
    const userId = this.data?.user?.id ?? null;
    const displayName = this.data?.displayName ?? this.data?.name ?? null;

    // Ensure current user appears in the dropdown options
    if (userId && this.data?.user && !this.users.some((u) => u.id === userId)) {
      const existingUser = {
        ...this.data.user,
        fullName: this.data.user.fullName
          || ((this.data.user.firstName || '') + ' ' + (this.data.user.lastName || '')).trim(),
      };
      this.users = [existingUser, ...this.users];
    }

    this.addLocationForm.patchValue({
      user: userId,
      displayName: displayName,
    });
    this.addLocationForm.controls['user'].disable();
  }

  onUserChange(event: any) {
    if (this.mode !== 'add') {
      return;
    }

    const selectedUser = this.users.find((u) => u.id === event?.value);
    this.addLocationForm.patchValue({
      displayName: selectedUser?.fullName || null,
    });
  }

  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
      }
    }));
  }

  /****************************************** Submit Data *****************************/
  onSubmitForm() {
    this.submitTouched = true;
    if (!this.addLocationForm.valid) {
      for (var i in this.addLocationForm.controls) {
        this.addLocationForm.controls[i].markAsTouched();
      }
      this.submitTouched = false;
      return false;
    }

    // getRawValue includes disabled controls (user in edit mode)
    const formValue = this.addLocationForm.getRawValue();
    const requestBody: any = {
      user: {
        id: formValue.user
      },
      displayName: formValue.displayName?.trim(),
      name: formValue.displayName?.trim(),
    };

    if (this.mode == 'add') {
      this.inventoryService.createBin(requestBody).subscribe((res: any) => {
        this.handleSubmitResponse(res, 'add');
      }, (err) => {
        this.handleSubmitError(err);
      });
    } else if (this.mode === 'edit') {
      requestBody.id = this.data?.id;
      this.inventoryService.updateBin(requestBody).subscribe((res: any) => {
        this.handleSubmitResponse(res, 'edit');
      }, (err) => {
        this.handleSubmitError(err);
      });
    }
  }

  private handleSubmitResponse(res: any, action: 'add' | 'edit') {
    if (res.status == 201 || res.status == 200) {
      const successMsg = action === 'add'
        ? this.translate?.general.messages.savedSuccessfully
        : this.translate?.general.messages.updatedSuccessfully;
      this.errorUtil.setErrorMessage(200, successMsg, null, 'success', 1000);
      this.modalRef.hide();
    } else {
      var errorTitle = res.error.title;
      if (res.error.type == 'dynamic-lang-error') {
        var data = res.error.instance + ".validationBE." + res.error.detail;
        var message = this.languageTranslateService.getNestedValue(this.translate, data);
        errorTitle = message;
      }

      this.errorUtil.setErrorMessage(
        res.status,
        null,
        errorTitle,
        "error",
        2000
      );
    }
    this.submitTouched = false;
  }

  private handleSubmitError(err: any) {
    this.spinner.hide();
    this.submitTouched = false;
    const title = this.errorUtil.processErrorTitle(err.error, this.translate);
    this.errorUtil.setErrorMessage(err.status, null, title, 'error', 3000);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
